// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__MZ67h","title_smaller":"Title_title_smaller__n9Iez"};